var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "#fff",
  viewBox: "0 0 17.644 17.644"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.753 0H1.89A1.89 1.89 0 0 0 0 1.89v13.863a1.89 1.89 0 0 0 1.89 1.89H7.3v-6H4.815V8.822H7.3V6.67a3.446 3.446 0 0 1 3.689-3.8 15 15 0 0 1 2.187.191v2.4H11.94a1.412 1.412 0 0 0-1.592 1.525v1.833h2.709l-.433 2.823h-2.276v6h5.405a1.89 1.89 0 0 0 1.89-1.89V1.89A1.89 1.89 0 0 0 15.753 0",
  className: "facebook_svg__a"
})));
export default SvgFacebook;